export default {
    setTotal : (context: any) : void => {
        context.commit('setTotal');
    },
    setItemNotif : (context: any, newData : any): void => {
        const resIndex = context.state.notif.findIndex( (item : any) => item.name === newData.name);
        if(resIndex !== -1){
            context.commit('setItemNotif',{index : resIndex, value : newData.value});
            context.dispatch('setTotal')
        }
        
    },
    addItem : (context: any, newData : any): void => {
        const resIndex = context.state.notif.findIndex( (item : any) => item.name === newData.name);
        if(resIndex < 0){
            context.commit('addItem', newData);
        }
        
    },
    
};
